import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { map } from 'rxjs/operators';
import { INationalHolidayDetail } from './interfaces/national-holiday-detail.interface';

@Component({
  selector: 'app-national-holiday-detail',
  templateUrl: './national-holiday-detail.component.html',
  styleUrls: ['./national-holiday-detail.component.scss'],
})
export class NationalHolidayDetailComponent implements OnInit {
  data: INationalHolidayDetail;

  constructor(private readonly route: ActivatedRoute) {}

  ngOnInit(): void {
    this.route.data.pipe(map((data: any) => data.pageData)).subscribe((data: any) => {
      if (!data) {
        this.placeholderData();
        return;
      }
      this.data = data;
    });
  }

  placeholderData(): void {
    this.data = {
      hero: {
        title: 'https://picsum.photos/200/300',
        body:
          '<p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. At    numquam atque iure ipsa corrupti itaque! Tenetur cumque commodi assumenda officiis alias    earum, velit unde, libero odit doloribus possimus veniam quam.</p>',

        color: 'red',
        image: 'https://picsum.photos/1000/2000',
      },
      content: [
        {
          title: 'Az ünnepről',
          subTitle: 'Az ünnep története',
          body:
            '<p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. At    numquam atque iure ipsa corrupti itaque! Tenetur cumque commodi assumenda officiis alias    earum, velit unde, libero odit doloribus possimus veniam quam.</p>',
          thumbnail: 'https://picsum.photos/600/500',
          color: 'red',
        },
      ],
    };
  }
}
